// Window name the Investigate popup is opened with. Reusing a fixed name lets a second
// window.open target the existing popup instead of spawning another one, and lets the
// popup recognise itself on boot.
export const RECORDINGS_POPUP_WINDOW_NAME = 'lh_recordings';

// Peer role under which the popup remembers the window that opened it.
export const RECORDINGS_POPUP_OPENER_PEER = 'recordings-popup-opener';

// Recordings filter an opener hands to the Investigate popup.
export interface IRecordingsPopupFilter {
    siteIds: string[];
    cameraId: string;
    startTimestamp: string;
}

// Investigate popup state held by the window that opens it.
export interface IInvestigatePopupState {
    filter: IRecordingsPopupFilter | null;
    popupWindowId: string | null;
    // True between opening the popup and answering its ready message. Only a pending
    // opener answers, so tabs never claim another tab's popup.
    pendingOpen: boolean;
}

export const initialInvestigatePopupState: IInvestigatePopupState = {
    filter: null,
    popupWindowId: null,
    pendingOpen: false,
};
